export class AdditionalSkills {
  ID: number;
  Name: string;
  TeachGroupId: number;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  IsDelivery: boolean;
}

export class CreateExpertise {
  TechGroupId: number;
  TechGroupName: string;
  StreamId: number;
  StreamName: string;
  PrimarySkillId: number;
  PrimarySkillName: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
}
